import { ReactNode } from 'react';
import { useAuthentication } from '@@auth/useAuthentication';
import { useDevCodeBypass } from '@@auth/useDevCodeBypass';
import { ErrorPage } from '@@core/ErrorPage';
import { Spinner } from '@@shared/base/Spinner';
import { shouldBypassDevCodeError } from '@@shared/utils/error';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { error: authError, isFetching: authIsFetching } = useAuthentication();
  const { error: bypassError, isFetching: bypassIsFetching } = useDevCodeBypass(authError);

  const error = shouldBypassDevCodeError(bypassError) ? authError : bypassError || authError;

  if (authIsFetching) return <Spinner isLoading center />;

  if (authError) {
    if (bypassIsFetching) {
      return <Spinner isLoading center />;
    }

    return <ErrorPage error={error} fullPageError />;
  }

  return <>{children}</>;
}
